import { useTranslation } from 'react-i18next'
import { EyeOff } from 'lucide-react'
import { Badge } from '@/components/ui'

export interface SupportSessionHiddenProps {
  /**
   * chip: "[ ซ่อน ]" where an image, a file or a link would be (slip images,
   * the lease PDF, attachments, ID images). text: the sentence
   * "ไม่แสดงในเซสชันของทีม FlowRent" where a value would be (an ID card number).
   */
  variant?: 'chip' | 'text'
  className?: string
  testId?: string
}

/**
 * EP-160 section 2.2, S3: in a FlowRent support session the operator API
 * removes every C3 value (a `<key>_present` marker replaces it, see
 * lib/sessionRedaction.ts), so the page shows this instead. Not a 403: the
 * rest of the page works.
 */
export function SupportSessionHidden({ variant = 'chip', className, testId = 'support-session-hidden' }: SupportSessionHiddenProps) {
  const { t } = useTranslation('common')
  const description = t('support_session.hidden_description')

  if (variant === 'text') {
    return (
      <span className={`inline-flex items-center gap-1 text-base-content/60 ${className ?? ''}`} data-testid={testId}>
        <EyeOff className="w-4 h-4 shrink-0" aria-hidden="true" />
        {description}
      </span>
    )
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`} data-testid={testId}>
      <Badge variant="ghost">{t('support_session.hidden')}</Badge>
      <span className="text-sm text-base-content/60">{description}</span>
    </span>
  )
}
